import { render, staticRenderFns } from "./sklShop.vue?vue&type=template&id=e39ac3de&"
import script from "./sklShop.vue?vue&type=script&lang=js&"
export * from "./sklShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports